module.exports = __webpack_public_path__ + "img/edge_restauration_traiteur.90ac8efa.svg";